import React, { useState, useRef, useEffect } from 'react';
import './AskQuestion.css';
import QuestionInput from './QuestionInput';
import QuestionAnswer from './QuestionAnswer';

// Import components
const CommonQuestions = React.lazy(() => import('./CommonQuestions'));

function AskQuestion() {
  const [selectedQuestion, setSelectedQuestion] = useState('');
  const answerRef = useRef(null);

  // Scroll to answer section when selectedQuestion changes
  useEffect(() => {
    if (selectedQuestion && answerRef.current) {
      const scrollToAnswer = () => {
        const yOffset = -100; // Adjust this value to control the scroll position
        const element = answerRef.current;
        const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
        
        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      };

      // Wait for the answer section to be rendered
      setTimeout(scrollToAnswer, 100);
    }
  }, [selectedQuestion]);

  const handleQuestionSelect = (question) => {
    setSelectedQuestion(question);
  };

  const handleQuestionSubmit = (question) => {
    console.log('Question submitted:', question);
    setSelectedQuestion(question);
  };

  return (
    <div className="ask-question-container">
      <main className="main-content">
        <div className="content-area">
          <div className="question-section">
            <React.Suspense fallback={<div>Loading...</div>}>
              <QuestionInput onSubmit={handleQuestionSubmit} />
              <CommonQuestions
                onQuestionSelect={handleQuestionSelect}
                selectedQuestion={selectedQuestion}
              />
              {selectedQuestion && (
                <div ref={answerRef} className="answer-section">
                  <QuestionAnswer question={selectedQuestion} />
                </div>
              )}
            </React.Suspense>
          </div>
        </div>
      </main>
    </div>
  );
}

export default AskQuestion; 